export default __webpack_public_path__ + "static/media/chocomugcake@3x.1e718f47.jpg";